import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import Form from "components/forms/form";
import FieldGrid from "components/grid/field-grid";
import Modal from "components/layout/modal";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import { buildDefaultValues, buildUserValidationSchema } from "lib/entity";
import { FormValues, fromFromValues } from "lib/form";
import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { userDoPostEntityCollection } from "services/user/entity-collection";

interface AddModalProps {
  listEntity: ListEntity;
  listEntityFields: ListEntityField[];
  onUpdate: () => Promise<void>;
  onClose: () => Promise<void>;
}

const AddModal: FunctionComponent<AddModalProps> = ({
  listEntity,
  listEntityFields,
  onUpdate,
  onClose,
}) => {
  const schema = buildUserValidationSchema(listEntityFields);

  const defaultValues = buildDefaultValues(listEntityFields, []);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const buttons: FormButtonInterface[] = [
    {
      ...CancelButton,
      onClick: onClose,
    },
    {
      ...SubmitButton,
      text: "Lisää",
      align: "full",
    },
  ];

  const onSubmit = async (formValues: FormValues) => {
    const entityCollectionValues = fromFromValues([], formValues);

    // create a new collection with values nested
    await userDoPostEntityCollection(listEntity.uuid, entityCollectionValues);

    // Update data on parent
    onUpdate();

    // close modal
    onClose();
  };

  return (
    <Modal title={"Lisää uusi"} wide>
      <Form methods={methods} onSubmit={onSubmit}>
        <FieldGrid listEntityFields={listEntityFields} />
        <FormButtons buttons={buttons} />
      </Form>
    </Modal>
  );
};

export default AddModal;
